import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import ApartmentCard from '../components/ApartmentCard';
import { getApartments } from '../api/client';
import './HomePage.css';

export default function HomePage() {
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getApartments()
      .then(setApartments)
      .catch(() => setError('Не удалось загрузить квартиры. Попробуйте позже.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="home-page">
      <Header />

      <main className="container home-main">

        {/* Quick check status */}
        <div className="status-check-bar">
          <span>Уже бронировали?</span>
          <form className="status-form" onSubmit={e => {
            e.preventDefault();
            const ref = e.target.ref.value.trim().toUpperCase();
            if (ref) window.location.href = `/booking/${ref}`;
          }}>
            <input
              name="ref"
              className="form-input status-input"
              placeholder="Номер брони (BK-2026-0001)"
              style={{ width: 220 }}
            />
            <button type="submit" className="btn btn-secondary" style={{ padding: '12px 16px' }}>
              Проверить статус
            </button>
          </form>
        </div>

        {loading && (
          <div className="home-loading">
            <div className="spinner" style={{ width: 40, height: 40 }} />
            <p>Загружаем квартиры...</p>
          </div>
        )}

        {error && <div className="alert alert-error">{error}</div>}

        {!loading && !error && (
          <>
            <h2 className="section-title">
              {apartments.length} {getNounForm(apartments.length, 'квартира', 'квартиры', 'квартир')} доступно
            </h2>
            <div className="apartments-grid">
              {apartments.map(apt => (
                <ApartmentCard key={apt.id} apartment={apt} />
              ))}
            </div>
          </>
        )}
      </main>
    </div>
  );
}

function getNounForm(n, form1, form2, form5) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 19) return form5;
  if (mod10 === 1) return form1;
  if (mod10 >= 2 && mod10 <= 4) return form2;
  return form5;
}